export default "__VITE_ASSET__M17cwSdv__"